<template>
  <v-row>
    <v-col cols="12">
      <v-row class="pa-1">
        <v-col cols="12" v-if="!entrepreneurship.published_by_admin" color="warning">
          <v-sheet
            outlined
            color="error"
            class="pa-4 white--text">
            El MODELO DE NEGOCIO se encuentra BLOQUEADA por el administrador para que no sea visible.
          </v-sheet>  
        </v-col>

        <v-col cols="12" v-if="!entrepreneurship.published" color="warning">
          <v-sheet
            outlined
            color="warning"
            class="pa-4 white--text">
            El MODELO DE NEGOCIO se encuentra como NO PUBLICADO.
          </v-sheet>  
        </v-col>

        <v-col cols="12" xl="8" md="8" sm="12">
          <section 
            :class="(entrepreneurship.title.length>100)?'section-title-large':'section-title'"
            v-if="!$vuetify.breakpoint.xsOnly">
            {{ entrepreneurship.title }}
          </section>

          <section class="section-title-xs" v-if="$vuetify.breakpoint.xsOnly">
            {{ entrepreneurship.title }}
          </section>
          
          <p class="font-weight-medium subtitle-1 text-justify">
            {{ entrepreneurship.slogan }}
          </p>

          <template v-if="entrepreneurship.country?.name?.toLowerCase() === 'argentina'">
            <div class="d-flex">
              <div width="42px">
                <v-img
                  max-height="38px"
                  max-width="38px"
                  contain
                  :src="url_flag"
                ></v-img>  
              </div>
              
              <div class="ml-2 my-auto text--secondary ">
                {{ entrepreneurship.provincia?.name?.toUpperCase() || '' }}
                <b v-if="entrepreneurship.provincia && entrepreneurship.country"> · </b>
                {{ entrepreneurship.country?.name?.toUpperCase() || '' }}
              </div>
            </div>
          </template>

          <template v-else-if="entrepreneurship.country?.name">
            <div class="d-flex">
              <div width="42px">
                <v-img
                  max-height="38px"
                  max-width="38px"
                  contain
                  :src="url_flag"
                ></v-img>  
              </div>
              
              <div class="ml-2 my-auto text--secondary ">
                {{ entrepreneurship.other_provincia ? entrepreneurship.other_provincia.toUpperCase() : '--' }}
                <b> · </b>
                {{ entrepreneurship.country?.name?.toUpperCase() }}
              </div>
            </div>
          </template>

          
          <div class="mt-4 mb-4" v-if="entrepreneurship.handle_like">
            <v-row class="section-likes">
              <v-btn
                icon
                x-large 
                color="red"
                :loading="loading_btn"
              >
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <label><small>0</small></label>
            </v-row>
          </div>

          <div class="mt-4 mb-4" v-if="!entrepreneurship.handle_like">
            <v-row class="section-likes">
              <v-btn
                icon
                x-large 
                color="red"
              >
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <label><small>{{ entrepreneurship.likes }}</small></label>
            </v-row>
          </div>
          
        </v-col>

        <v-col class="pt-8" cols="12" xl="4" md="4" sm="12">
          <v-row>
            <v-col cols="6" class="section-logos">
              <v-img
                v-if="url_logo"
                style="cursor: pointer;"
                class="rounded"
                contain
                v-bind:src="url_logo"
                max-height="120px"
                @click="showImage(0)"
              ></v-img>
            </v-col>
            <v-col cols="6" class="text-center section-logos">
              <v-img
                contain
                v-bind:src="logo_modelo_url"
                max-height="120px"
              ></v-img>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" xl="12" md="12" sm="12" class="mt-4 mb-4" v-if="!$vuetify.breakpoint.xsOnly">
          <v-row class="d-flex justify-space-between mb-6 overflow-x-auto">
            <v-col class="width-image">
              <v-img
                style="cursor: pointer;"
                class="rounded elevation-1"
                fixed
                :src="url_image_1"
                height="320px"
                @click="showImage(1)"
              ></v-img>
            </v-col>

            <v-col class="my-auto width-image">
              <v-img
                style="cursor: pointer;"
                class="rounded elevation-1"
                fixed
                :src="url_image_2"
                height="220px"
                @click="showImage(2)"
              ></v-img>
            </v-col>

            <v-col class="width-image">
              <v-img
                style="cursor: pointer;"
                class="rounded elevation-1"
                fixed
                :src="url_image_3"
                height="320px"
                @click="showImage(3)"
              ></v-img>
            </v-col>

            <v-col class="my-auto width-image">
              <v-img
                style="cursor: pointer;"
                class="rounded elevation-1"
                fixed
                :src="url_image_4"
                height="220px"
                @click="showImage(4)"
              ></v-img>
            </v-col>

            <v-col class="width-image">
              <v-img
                style="cursor: pointer;"
                class="rounded elevation-1"
                fixed
                :src="url_image_5"
                height="320px"
                @click="showImage(5)"
              ></v-img>
            </v-col>

          </v-row>
        </v-col>

        <v-col cols="12" class="mt-4 mb-4" v-if="$vuetify.breakpoint.xsOnly">
          <section class="d-flex justify-space-between mb-6 overflow-x-auto">

            <v-img
              style="cursor: pointer;"
              class="rounded elevation-1 ma-2"
              fixed
              :src="url_image_1"
              height="320px"
              max-width="160px"
              @click="showImage(1)"
            ></v-img>

            <v-img
              style="cursor: pointer;"
              class="rounded elevation-1 ma-2 my-auto"
              fixed
              :src="url_image_2"
              height="220px"
              max-width="160px"
              @click="showImage(2)"
            ></v-img>

            <v-img
              style="cursor: pointer;"
              class="rounded elevation-1 ma-2"
              fixed
              :src="url_image_3"
              height="320px"
              max-width="160px"
              @click="showImage(3)"
            ></v-img>

            <v-img
              style="cursor: pointer;"
              class="rounded elevation-1 ma-2 my-auto"
              fixed
              :src="url_image_4"
              height="220px"
              max-width="160px"
              @click="showImage(4)"
            ></v-img>

            <v-img
              style="cursor: pointer;"
              class="rounded elevation-1 ma-2"
              fixed
              :src="url_image_5"
              height="320px"
              max-width="160px"
              @click="showImage(5)"
            ></v-img>

          </section>
        </v-col>

        <v-col cols="12" xl="8" md="8" sm="12">

          <p class="text--secondary body-1 text-justify">
            {{ entrepreneurship.description }}
          </p>

          <v-row class="pt-4 ma-0" v-if="entrepreneurship.video">
            <v-col class="content-video d-flex justify-center align-center">
              <LazyYoutube class="video" :src="entrepreneurship.video" />
            </v-col>
          </v-row>   
        </v-col>

        <v-col 
          cols="12" 
          xl="4" 
          md="4" 
          sm="12">
          <v-row>
            <v-col 
              cols="12"
              v-if="entrepreneurship.web || entrepreneurship.email || entrepreneurship.whatsapp">
              

              <v-list-item>
                
                <v-list-item-content>

                  <h3 class="title-2">CONTACTO</h3>
                  <hr :style="{ backgroundColor: color, color: color, height: '4px', borderRadius: '4px', border: 'none' }">
                  
                  <v-list-item-title 
                    class="pt-4"
                    v-if="entrepreneurship.web">
                    <a 
                      :href="entrepreneurship.web"
                      class="mr-1 pb-2 links" 
                      target="_blank">
                      <v-icon>
                        mdi-web
                      </v-icon>
                      {{ entrepreneurship.web }}
                    </a>
                  </v-list-item-title>

                  <v-list-item-title 
                    class="pt-4"
                    v-if="entrepreneurship.email">
                    <a 
                      :href="'mailto:'+entrepreneurship.email"
                      class="mr-1 pb-2 links" 
                      target="_blank">
                      <v-icon>
                        mdi-email
                      </v-icon>
                      {{ entrepreneurship.email }}
                    </a>
                  </v-list-item-title>

                  <v-list-item-title 
                    class="pt-4"
                    v-if="entrepreneurship.whatsapp">
                    <a 
                      :href="'https://api.whatsapp.com/send?phone=' + entrepreneurship.whatsapp + '&text=' + encodeURIComponent('Hola, vi tu emprendimiento en la JIJE y me gustaría hacerte un par de consultas.')"
                      class="mr-1 pb-2 links" 
                      target="_blank">
                      <v-icon>
                        mdi-whatsapp
                      </v-icon>
                      {{ entrepreneurship.whatsapp }}
                    </a>
                  </v-list-item-title>
                  
                </v-list-item-content>
              </v-list-item>
            </v-col>
            
            <v-col 
              cols="12"
              v-if="entrepreneurship.linkedin || entrepreneurship.facebook || entrepreneurship.instagram || entrepreneurship.twitter || entrepreneurship.youtube">
              
              <h3 class="title-2 pl-4">REDES</h3>
              <hr class="ml-4 mr-4" :style="{ backgroundColor: color, color: color, height: '4px', borderRadius: '4px', border: 'none' }">
              <v-col class="section-social pl-4">
                <a 
                  v-if="entrepreneurship.linkedin" 
                  :href="entrepreneurship.linkedin"
                  class="mr-1 pb-2" 
                  target="_blank">
                  <v-icon>
                    mdi-linkedin
                  </v-icon>
                </a>
                
                <a 
                  v-if="entrepreneurship.facebook" 
                  :href="entrepreneurship.facebook" 
                  class="mr-1 pb-2"
                  target="_blank">
                  <v-icon>
                    mdi-facebook
                  </v-icon>
                </a>
                
                <a 
                  v-if="entrepreneurship.instagram" 
                  :href="entrepreneurship.instagram" 
                  class="mr-1 pb-2"
                  target="_blank">
                  <v-icon>
                    mdi-instagram
                  </v-icon>
                </a>

                <a 
                  v-if="entrepreneurship.twitter" 
                  :href="entrepreneurship.twitter" 
                  class="mr-1 pb-2"
                  target="_blank">
                  <v-icon>
                    mdi-twitter
                  </v-icon>
                </a>

                <a 
                  v-if="entrepreneurship.youtube" 
                  :href="entrepreneurship.youtube" 
                  class="mr-1 pb-2"
                  target="_blank">
                  <v-icon>
                    mdi-youtube
                  </v-icon>
                </a>

                <a 
                  v-if="entrepreneurship.telegram" 
                  :href="entrepreneurship.telegram" 
                  class="mr-1 pb-2"
                  target="_blank">
                  <v-icon>
                    mdi-send-variant
                  </v-icon>
                </a>

                <a 
                  v-if="entrepreneurship.discord" 
                  :href="entrepreneurship.discord" 
                  class="mr-1 pb-2"
                  target="_blank">
                  <v-icon>
                    mdi-discord
                  </v-icon>
                </a>

                <a 
                  v-if="entrepreneurship.twitch" 
                  :href="entrepreneurship.twitch" 
                  class="mr-1 pb-2"
                  target="_blank">
                  <v-icon>
                    mdi-twitch
                  </v-icon>
                </a>

                <a 
                  v-if="entrepreneurship.tiktok" 
                  :href="entrepreneurship.tiktok" 
                  class="mr-1 pb-2"
                  target="_blank">
                  <v-img  
                    contain
                    height="20px" 
                    width="20px"
                    position="center" 
                    :src="require('@/assets/icons/tiktok.png')">
                  </v-img>
                </a>

                <a 
                  v-if="entrepreneurship.snapchat" 
                  :href="entrepreneurship.snapchat" 
                  class="mr-1 pb-2"
                  target="_blank">
                  <v-icon>
                    mdi-snapchat
                  </v-icon>
                </a>

              </v-col>
            </v-col>

            <v-col cols="12" class="mt-4 pl-6">
              <v-btn 
                :color="color"
                block
                :style="{ color: (project_gallery_mode)?'white':'black' }"
                v-if="entrepreneurship.brochure_1 || entrepreneurship.brochure_2 || entrepreneurship.brochure_3"
                @click="dialog_brochures=!dialog_brochures">
                + Info
              </v-btn>
            </v-col>
            
            <v-col cols="12" class="mt-4">
              <h3 class="title-2 pl-4">EQUIPO</h3>
              <hr class="ml-4 mr-4" :style="{ backgroundColor: color, color: color, height: '4px', borderRadius: '4px', border: 'none' }">
              <v-list-item v-for="member in team" :key="member.id">
                <v-list-item-content class="ma-0">

                  <v-list-item-title @click="showMember(member)" style="cursor: pointer;" class="ma-0">
                    <v-icon large>
                      mdi-account-circle-outline
                    </v-icon>
                      {{member.lastname.toUpperCase() + ', ' + member.name }}
                  </v-list-item-title>

                </v-list-item-content>
              </v-list-item>
            </v-col>

          </v-row>

        </v-col>
      </v-row>
    </v-col>

    <v-dialog
      v-model="dialog_entrepreneur"
      max-width="380"
    >
      <v-card v-if="entrepreneur.name">
        <v-card-text>
          <cardEntrepreneurDialog :data="entrepreneur"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="dialog_entrepreneur = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_brochures"
      max-width="380"
    >
      <v-card>
        <v-card-title>
          Brochures:
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="pa-2 pt-8" v-if="entrepreneurship.brochure_1">
              <v-btn 
                class="pa-4 mt-2 pt-5"
                :color="color"
                :style="{ color: (project_gallery_mode)?'white':'black' }"
                block
              >
                <a :href="url_brochure_1" target="_blank" style="text-decoration: none; color: inherit;">
                  <v-icon left>
                    mdi-arrow-down
                  </v-icon>
                  Descargar
                </a>
              </v-btn>
            </v-col>

            <v-col cols="12" class="pa-2" v-if="entrepreneurship.brochure_2">
              <v-btn 
                class="pa-4 mt-2 pt-5"
                :color="color"
                :style="{ color: (project_gallery_mode)?'white':'black' }"
                block
              >
                <a :href="url_brochure_2" target="_blank" style="text-decoration: none; color: inherit;">
                  <v-icon left>
                    mdi-arrow-down
                  </v-icon>
                  Descargar
                </a>
              </v-btn>
            </v-col>

            <v-col cols="12" class="pa-2" v-if="entrepreneurship.brochure_3">
              <v-btn 
                class="pa-4 mt-2 pt-5"
                :color="color"
                :style="{ color: (project_gallery_mode)?'white':'black' }"
                block
              >
                <a :href="url_brochure_3" target="_blank" style="text-decoration: none; color: inherit;">
                  <v-icon left>
                    mdi-arrow-down
                  </v-icon>
                  Descargar
                </a>
              </v-btn>
            </v-col>
          </v-row>
          
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="dialog_brochures = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </v-row>
</template>

<script>
  const APP_URL = process.env.VUE_APP_URL
  import cardEntrepreneurDialog from '@/components/card/cardEntrepreneurDialog.vue'
  import { LazyYoutube } from "vue-lazytube" 

  export default {
    name: 'showBusinessModelsStand',
    components: {
      LazyYoutube,
      cardEntrepreneurDialog
    },
    props:['data', 'logo', 'color', 'project_gallery_mode'],
    data: () => ({
      loading_btn:false,
      dialog_entrepreneur:false,
      dialog_brochures:false,

      entrepreneurship:null,
      entrepreneur:[],
      team:null,
      url_flag:null,
      url_logo: null,
      logo_modelo_url: null,
      url_brochure_1:null,
      url_brochure_2:null,
      url_brochure_3:null,
      url_image_1: null,
      url_image_2: null,
      url_image_3: null,
      url_image_4: null,
      url_image_5: null,
      images_window: [],
      image_window:[],
      cols:8,
      color_icons:'#606060',
      color_users: '#FF41BE'
    }),
    methods:{
      showImage(image) {
        let images_aux = this.images_window
        images_aux = this.rotate(images_aux, image)
        this.$viewerApi({
          images: images_aux,
            options: {
              toolbar: false,
              title: false,
              button: true,
            }
        })
      },

      rotate(arr, count = 1){
        return [...arr.slice(count, arr.length), ...arr.slice(0, count)];
      },

      setData(){
        this.entrepreneurship = this.data.window
        this.team = this.data.team
        this.logo_modelo_url = APP_URL + this.logo

        if(this.entrepreneurship.handle_like==false){
          this.entrepreneurship.handle_like = false
        }else{
          this.entrepreneurship.handle_like = true
        }

        this.url_flag = this.entrepreneurship.country?.flag ? APP_URL + this.entrepreneurship.country.flag : null;

        if(this.entrepreneurship.brochure_1){
          this.url_brochure_1 = APP_URL + this.entrepreneurship.brochure_1
        }

        if(this.entrepreneurship.brochure_2){
          this.url_brochure_2 = APP_URL + this.entrepreneurship.brochure_2
        }

        if(this.entrepreneurship.brochure_3){
          this.url_brochure_3 = APP_URL + this.entrepreneurship.brochure_3
        }
        
        if(this.entrepreneurship.logo){
          this.url_logo = APP_URL + this.entrepreneurship.logo
          this.images_window.push(this.url_logo)
        }

        if(this.entrepreneurship.image_1){
          this.url_image_1 = APP_URL + this.entrepreneurship.image_1
          this.images_window.push(this.url_image_1)
        }

        if(this.entrepreneurship.image_2){
          this.url_image_2 = APP_URL + this.entrepreneurship.image_2
          this.images_window.push(this.url_image_2)
        }

        if(this.entrepreneurship.image_3){
          this.url_image_3 = APP_URL + this.entrepreneurship.image_3
          this.images_window.push(this.url_image_3)
        }

        if(this.entrepreneurship.image_4){
          this.url_image_4 = APP_URL + this.entrepreneurship.image_4
          this.images_window.push(this.url_image_4)
        }

        if(this.entrepreneurship.image_5){
          this.url_image_5 = APP_URL + this.entrepreneurship.image_5
          this.images_window.push(this.url_image_5)
        }

        if(this.entrepreneurship.image_6){
          this.url_image_6 = APP_URL + this.entrepreneurship.image_6
          this.images_window.push(this.url_image_6)
        }

        if( this.entrepreneurship.logo ||
            this.entrepreneurship.image_1 || 
            this.entrepreneurship.image_2 ||
            this.entrepreneurship.image_3 ||
            this.entrepreneurship.image_4)
        {
          this.cols =8
        }else{
          this.cols =12
        }
      }, 

      showMember(member){
        this.entrepreneur = member
        this.dialog_entrepreneur = true
      }
    },
    created(){
      this.setData()
    }
  }
</script>
<style scoped>
hr {
  color: #FF41BE; 
  background-color: #FF41BE;
  height: 3px;
}
.links{
  text-decoration: none;
  color: inherit;
}
.content-video {
  border-radius: 5px;
  padding: 0%;
  background-color: white;
  justify-content:center;
}
.video{
  max-width: 100%;
  z-index: 0;
  height: 100%;
}

.section-title {
  height: 130px;
  display: flex;
  align-items: center;
  font-size: 38px;
  font-weight: 600;
  color: #04A5B7;
}
.section-title-large {
  height: 130px;
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 600;
  color: #04A5B7;
}
.section-title-xs {
  height: 130px;
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 600;
  color: #04A5B7;
}

.section-logos {
  display: flex;
  justify-content:space-evenly;
  align-items: center;
}

.section-likes {
  display: flex;
  margin-right: -10px;
  align-items: center;
  height: 28px;
}

.section-social {
  display: flex;
  margin-right: -10px;
  align-items: center;
  align-content: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.width-image{
  width: 20%!important;
}

.width-image-sm {
  width: 20%!important;
}
.scrolling{
  display: flex;
  overflow-x: auto;
}
</style>